import {
  AUTH_BY_CONTRACT,
  AUTH_BY_CONTRACT_EPARGN_EMAIL,
  AUTH_BY_CONTRACT_EPARGN_EMAIL_CODE_INPUT,
  AUTH_BY_CONTRACT_EPARGN_FAILED,
  AUTH_BY_CONTRACT_EPARGN_SMS,
  AUTH_BY_CONTRACT_EPARGN_SUCCESS,
  AUTH_BY_SMS,
  AUTH_EPARGN_SMS_UNVALID_USER,
  CONTRACT_FOUND_NOT_NUM,
  CONTRACT_NOT_FOUND,
  CREATE_PASSWORD,
  CREATE_PASSWORD_EPARGN_UNVALID_USER,
  ID_MEMO,
  ID_MEMO_EPARGN_UNVALID_USER,
  PERSONAL_INFO,
  SEND_EMAIL_VERIFICATION_UNVALID_USER,
  VERIFY_EMAIL_EPARGN_UNVALID_USER,
  VERIFY_IDENTITY,
} from 'containers/SignupPages/constants';
import { pushTo } from 'helpers/routes';
import { isEmpty } from 'lodash';
import get from 'lodash/get';
import moment from 'moment';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import PAGES from 'routes/pages';
import { setAuthContratEpargn } from 'store/contract/actions';
import { authByContract } from 'store/contract/saga';
import { setSelectedTab, SetTabs, setToasterOpen } from 'store/global/actions';
import { getAllNotifications, setNotificationReadApi } from 'store/global/api';
import { getTabsSelector } from 'store/global/selectors';
import { getLocaleSelector } from 'store/LanguageProvider/selectors';
import {
  getUserInfoFail,
  getUserInfoSuccess,
  loginFail,
  loginSuccesss,
  NotificationReadPayload,
  setEmail,
  setIdentityImages,
  setIsUserFound,
  setNotificationReadFailure,
  setNotificationReadSucces,
  setNotifications,
  setPinId,
  setProfileSettingsInfo,
  setSignupStep,
  setToken,
  setUserInfo,
  submitSignupStepFail,
  submitSignupStepSuccess,
  updateProfileSettingsInfoFail,
  updateProfileSettingsInfoSuccess,
} from 'store/user/actions';
import {
  addNewUser,
  getProfileSettingsInfoApi,
  getUserInfoAPI,
  sendEmailSubscription,
  sendLoginViaMailOnboarding,
  updateProfileSettingsInfoAPI,
  userLogin,
  verifyElegibility,
  verifyEmail as verifyEmailApi,
  verifyIdentityAPI,
  verifySms,
  verifySmsEpargnUnvalidUser,
} from 'store/user/apis';
import {
  GET_NOTIFICATIONS,
  GET_PROFILE_SETTINGS_INFO,
  GET_USER_INFO,
  LOGIN_REQUEST,
  RESEND_EMAIL,
  SET_NOTIFICATION_READ,
  SUBMIT_SIGNUP_STEP,
  UPDATE_PROFILE_SETTINGS_INFO,
} from 'store/user/constants';
import {
  getCurrentSignupStepNameSelector,
  getEmailSelector,
  getIdentityImages,
  getLoginSelector,
  getPinIdSelector,
  getTokenSelector,
  mapNotificationResponsetoModel,
  userSelector,
} from 'store/user/selectors';
import {
  createPasswordDataType,
  formLoginPayloadType,
  UpdateProfileSettingsInfoType,
} from 'store/user/types';
import { tabsFromResponse } from 'utils/string';

export function* afterLoginSuccess(roles: any) {
  const tabs = tabsFromResponse(roles);
  yield put(SetTabs(tabs));
  yield put(setSelectedTab(tabs[0]?.type));
  yield call(pushTo, tabs[0]?.path);
  localStorage.setItem('tabs', JSON.stringify(tabs));
}

export function* setNotificationRead({
  payload,
}: {
  type: typeof setNotificationRead;
  payload: NotificationReadPayload;
}) {
  try {
    const { data: response } = yield call(setNotificationReadApi, {
      id: payload.id,
    });
    if (response.success) {
      yield put(setNotificationReadSucces(payload));
    } else {
      yield put(setNotificationReadFailure());
    }
  } catch (err) {
    yield put(setNotificationReadFailure());
  }
}
export function* watchSetNotificationRead() {
  yield takeLatest(SET_NOTIFICATION_READ, setNotificationRead);
}

export function* getNotificationsSaga() {
  const notificationResponse = yield call(getAllNotifications);
  yield put(
    setNotifications(
      mapNotificationResponsetoModel(notificationResponse.data.data),
    ),
  );
}

export function* watchGetNotifications() {
  yield takeLatest(GET_NOTIFICATIONS, getNotificationsSaga);
}

export function* login({
  payload,
}: {
  type: typeof LOGIN_REQUEST;
  payload: formLoginPayloadType;
}) {
  try {
    const { identifiant, password } = payload;
    const { data: response } = yield call(userLogin, {
      login: identifiant,
      password,
    });

    const {
      token,
      first_name,
      last_name,
      phone_number,
      ...client
    } = response.data;
    /* istanbul ignore next */
    localStorage.setItem('token', token);
    yield put(
      loginSuccesss({
        ...client,
        firstName: first_name,
        lastName: last_name,
        phone: phone_number,
      }),
    );
    yield call(afterLoginSuccess, response.data.roles);
  } catch (error) {
    if (get(error, 'response.data.code_error') === 2009) {
      yield call(pushTo, PAGES.EPARGN_PENDING_VERIFICATION);
      yield put(loginSuccesss({}));
    } else {
      const messageError = get(error, 'response.data.message');
      if (!isEmpty(messageError)) {
        yield put(loginFail(messageError));
      } else {
        yield put(
          setToasterOpen({
            title: 'defaultErrorMessage',
            severity: 'error',
          }),
        );
        yield put(loginFail({}));
      }
    }
  }
}

export function* watchUserAuth() {
  yield takeLatest(LOGIN_REQUEST, login);
}

export function* submitSignupStep({
  payload,
}: {
  type: typeof SUBMIT_SIGNUP_STEP;
  payload: any;
}) {
  const currentSignupStepName = yield select(getCurrentSignupStepNameSelector);

  switch (currentSignupStepName) {
    case PERSONAL_INFO:
      yield call(personalInfo, payload);
      break;
    case AUTH_BY_CONTRACT:
      yield call(authByContract, payload);
      break;
    case ID_MEMO_EPARGN_UNVALID_USER:
    case ID_MEMO:
      yield call(idMemo, payload);
      break;
    case CREATE_PASSWORD:
      yield call(createPassword, payload);
      break;
    case AUTH_BY_SMS:
      yield call(authBySms, payload);
      break;
    case AUTH_BY_CONTRACT_EPARGN_SMS:
      yield call(authBySmsEpargn, payload);
      break;
    case AUTH_BY_CONTRACT_EPARGN_EMAIL:
      yield call(authByEmail, payload);
      break;
    case AUTH_BY_CONTRACT_EPARGN_EMAIL_CODE_INPUT:
      yield call(verifyEmail, payload);
      break;
    case AUTH_EPARGN_SMS_UNVALID_USER:
      yield call(authBySmsEpargnUnvalidUser, payload);
      break;
    case VERIFY_IDENTITY:
      yield call(verifyIdentity, payload);
      break;
    case SEND_EMAIL_VERIFICATION_UNVALID_USER:
      yield call(sendEmailUnvalidUser, payload);
      break;
    case VERIFY_EMAIL_EPARGN_UNVALID_USER:
      yield call(verifyEmailUnvalidUser, payload);
      break;
    case CREATE_PASSWORD_EPARGN_UNVALID_USER:
      yield call(createPassword, payload);
      break;
    default:
      break;
  }
}

export function* createPassword(data: createPasswordDataType) {
  try {
    const {
      firstName,
      lastName,
      cin,
      phone,
      bday,
      email,
      identifiant: login,
    } = yield select(userSelector);
    const token = yield select(getTokenSelector);
    const language = yield select(getLocaleSelector);
    const image = yield select(getIdentityImages);
    const base64Image = !isEmpty(image) ? image.split('base64,') : '';
    const dataToSend = {
      password: data.password,
      confirm: data.confirmPassword,
      id_question: data.questionSecret,
      response_question: data.response,
      image: base64Image[1],
      firstName,
      lastName,
      cin,
      bday,
      phone,
      token,
      login,
      language,
      email,
    };
    const { data: response } = yield call(addNewUser, dataToSend);
    if (response.success) {
      if (!isEmpty(base64Image[1])) {
        yield call(pushTo, PAGES.EPARGN_PENDING_VERIFICATION);
        localStorage.removeItem('token');
      } else {
        const { login, token, roles } = response.data;
        yield put(submitSignupStepSuccess({ login, token, roles }));
        localStorage.setItem('token', token);
        yield call(afterLoginSuccess, response.data.roles);
        localStorage.removeItem('personalInfo');
      }
    } else {
      const { message } = response;
      yield put(submitSignupStepFail(message));
    }
  } catch (error) {
    yield put(
      setToasterOpen({
        title: 'signupFailed',
        severity: 'error',
      }),
    );
    yield put(submitSignupStepFail(error));
  }
}

export function* personalInfo(data: any) {
  try {
    const bday = moment(data.bday).format('DD/MM/YYYY');
    const dateEffet =
      data.dateEffet && moment(data.dateEffet).format('DD/MM/YYYY');
    const phone = data.phone.split(' ').join('').replace('+212', '0');

    const userInfo = {
      firstName: data.firstName,
      email: data.email,
      lastName: data.lastName,
      phone: data.phone,
      birthday: data.bday,
      cin: data.cin,
    };
    localStorage.setItem('personalInfo', JSON.stringify(userInfo));

    yield put(
      setUserInfo({
        bday,
        cin: data.cin,
        email: data.email,
        firstName: data.firstName,
        lastName: data.lastName,
        phone,
      }),
    );

    const language = yield select(getLocaleSelector);

    const { data: response } = yield call(verifyElegibility, {
      ...data,
      bday,
      phone,
      language,
      dateEffet,
    });

    if (response.success) {
      if (response.data.code_error === 2002) {
        yield put(
          setToasterOpen({
            title: 'emailAlreadyExist',
            severity: 'error',
          }),
        );
      }
      if (response.data.code_error === 1009) {
        yield put(
          setToasterOpen({
            title: 'accountAlreadyExist',
            severity: 'error',
          }),
        );
        yield put(setSignupStep(PERSONAL_INFO));
      }
      if (response.data.code_error === 1000) {
        yield put(setToken(response.data.token));
        localStorage.setItem('token', response.data.token);
        yield put(setSignupStep(CONTRACT_NOT_FOUND));
      } else if (response.data.code_error === 1001) {
        yield put(setToken(response.data.token));
        yield put(setIsUserFound());
        localStorage.setItem('token', response.data.token);
        yield put(setSignupStep(CONTRACT_FOUND_NOT_NUM));
      } else if (response.data.code_error === 1003) {
        yield put(
          setToasterOpen({
            title: 'serviceUnavailable',
            severity: 'error',
          }),
        );
        yield put(submitSignupStepFail('serviceUnavailable'));
      } else if (
        response.data.pinId &&
        response.data.message === 'PIN sent to client'
      ) {
        yield put(setToken(response.data.token));
        yield put(setPinId(response.data.pinId));
        if (data.isContratEpargne) {
          yield put(
            setAuthContratEpargn({
              name: `${data.firstName} ${data.lastName}`,
              numContrat: data.numPolice,
              dateEffet,
            }),
          );
          yield put(setSignupStep(AUTH_BY_CONTRACT_EPARGN_SUCCESS));
        } else {
          yield put(setSignupStep(AUTH_BY_SMS));
        }
      }
    } else {
      yield put(submitSignupStepFail('false success response'));
    }
  } catch (error) {
    if (get(error, 'response.data.data.code_error') === 2008) {
      yield put(setToken(get(error, 'response.data.data.token')));
      localStorage.setItem('token', get(error, 'response.data.data.token'));
      yield put(setSignupStep(AUTH_BY_CONTRACT_EPARGN_FAILED));
    } else yield put(setSignupStep(CONTRACT_NOT_FOUND));
  }
}

export function* idMemo({
  email,
  login,
  inMyAddressMail,
}: {
  email: string;
  login: string;
  inMyAddressMail: boolean;
}) {
  try {
    if (inMyAddressMail) {
      const language = yield select(getLocaleSelector);
      const token = yield select(getTokenSelector);
      yield call(sendLoginViaMailOnboarding, { email, login, token, language });
      yield put(submitSignupStepSuccess({}));
    }
    yield put(setSignupStep(CREATE_PASSWORD));
  } catch (error) {
    yield put(submitSignupStepFail(error));
  }
}

export function* authByEmail({ email }: { email: string }) {
  yield put(setEmail(email));
  const token = yield select(getTokenSelector);
  const language = yield select(getLocaleSelector);
  try {
    const { data: response } = yield call(sendEmailSubscription, {
      token,
      email,
      language,
    });
    yield put(
      submitSignupStepSuccess({
        token: response.data.token,
      }),
    );
    yield put(setSignupStep(AUTH_BY_CONTRACT_EPARGN_EMAIL_CODE_INPUT));
  } catch (error) {
    yield put(submitSignupStepFail(error));
  }
}

export function* resendEMail() {
  const token = yield select(getTokenSelector);
  const language = yield select(getLocaleSelector);
  const email = yield select(getEmailSelector);
  try {
    const { data: response } = yield call(sendEmailSubscription, {
      token,
      email,
      language,
    });
    yield put(
      submitSignupStepSuccess({
        token: response.data.token,
      }),
    );
    yield put(setSignupStep(AUTH_BY_CONTRACT_EPARGN_EMAIL_CODE_INPUT));
    yield put(setToasterOpen({ title: 'newEmailSent', severity: 'info' }));
  } catch (error) {
    // yield put(setToasterOpen({ title: '', severity: 'warning' }));
    yield put(submitSignupStepFail(error));
  }
}

export function* watchResendByEmail() {
  yield takeLatest(RESEND_EMAIL, resendEMail);
}
export function* sendEmailUnvalidUser({ email }: { email: string }) {
  try {
    const language = yield select(getLocaleSelector);
    const token = yield select(getTokenSelector);
    const { data: response } = yield call(sendEmailSubscription, {
      email,
      token,
      language,
    });
    yield put(
      submitSignupStepSuccess({
        token: response.data.token,
      }),
    );
    yield put(setSignupStep(VERIFY_EMAIL_EPARGN_UNVALID_USER));
  } catch (error) {
    yield put(submitSignupStepFail(error));
  }
}
export function* verifyEmailUnvalidUser({ pin }: { pin: string }) {
  try {
    const token = yield select(getTokenSelector);
    const { data: response } = yield call(verifyEmailApi, {
      pin,
      token,
    });
    yield put(
      submitSignupStepSuccess({
        token: response.data.token,
      }),
    );
    yield put(setSignupStep(ID_MEMO_EPARGN_UNVALID_USER));
  } catch (error) {
    yield put(submitSignupStepFail(error));
  }
}

export function* verifyEmail({ pin }: { pin: string }) {
  const token = yield select(getTokenSelector);
  try {
    const { data: response } = yield call(verifyEmailApi, {
      token,
      pin,
    });
    yield put(
      submitSignupStepSuccess({
        token: response.data.token,
      }),
    );
    yield put(setSignupStep(ID_MEMO));
  } catch (error) {
    yield put(submitSignupStepFail(error));
  }
}

export function* authBySms({ pin }: { pin: string }) {
  try {
    const pinId = yield select(getPinIdSelector);
    const token = yield select(getTokenSelector);
    const { data: response } = yield call(verifySms, { pin, pinId, token });
    yield put(
      submitSignupStepSuccess({
        token: response.data.token,
        login: response.data.login,
      }),
    );
    yield put(setSignupStep(ID_MEMO));
  } catch (error) {
    yield put(submitSignupStepFail(error));
  }
}

export function* authBySmsEpargn({ pin }: { pin: string }) {
  try {
    const pinId = yield select(getPinIdSelector);
    const token = yield select(getTokenSelector);
    const { data: response } = yield call(verifySms, { pin, pinId, token });
    if (response.success) {
      yield put(
        submitSignupStepSuccess({
          token: response.data.token,
          login: response.data.login,
        }),
      );
      yield put(setSignupStep(AUTH_BY_CONTRACT_EPARGN_EMAIL));
    } else {
      if (response.code_error === 1004) {
        yield put(
          setToasterOpen({
            title: 'pinIncorrect',
            severity: 'error',
          }),
        );
        yield put(submitSignupStepFail('Pin not correct'));
      }
    }
  } catch (error) {
    yield put(submitSignupStepFail(error));
  }
}
export function* authBySmsEpargnUnvalidUser({ pin }: { pin: string }) {
  try {
    const pinId = yield select(getPinIdSelector);
    const token = yield select(getTokenSelector);
    const { data: response } = yield call(verifySmsEpargnUnvalidUser, {
      pin,
      pinId,
      token,
    });
    yield put(
      submitSignupStepSuccess({
        token: response.data.token,
        login: response.data.login,
      }),
    );
    yield put(setToken(get(response, 'data.token')));
    yield put(setSignupStep(SEND_EMAIL_VERIFICATION_UNVALID_USER));
  } catch (error) {
    yield put(submitSignupStepFail(error));
  }
}

export function* watchSubmitSignupStep() {
  yield takeLatest(SUBMIT_SIGNUP_STEP, submitSignupStep);
}

export function* getProfileSettingsInfo() {
  try {
    const login = yield select(getLoginSelector);
    const response = yield call(getProfileSettingsInfoApi, login);
    const dataReceived = response.data.data;
    const profileSettingInfo = {
      firstName: get(dataReceived, 'menu[0].data'),
      lastName: get(dataReceived, 'menu[1].data'),
      cin: get(dataReceived, 'menu[2].data'),
      email: get(dataReceived, 'input.email'),
      phone: get(dataReceived, 'input.phoneNumber'),
      bday: get(dataReceived, 'input.dob'),
      isNotifEnabled: get(dataReceived, 'notification_enabled'),
      language: get(dataReceived, 'default_language'),
    };
    yield put(setProfileSettingsInfo(profileSettingInfo));
  } catch (error) {
    yield put(
      setToasterOpen({
        title: 'defaultErrorMessage',
        severity: 'error',
      }),
    );
  }
}

export function* watchGetProfileSettingsInfo() {
  yield takeLatest(GET_PROFILE_SETTINGS_INFO, getProfileSettingsInfo);
}

export function* updateProfileSettingsInfo({
  payload,
}: UpdateProfileSettingsInfoType) {
  try {
    const { data } = yield call(updateProfileSettingsInfoAPI, {
      ...payload,
      bday: payload.bday.split('-').reverse().join('/'),
    });
    if (get(data, 'success')) {
      yield put(
        setToasterOpen({
          title: 'profileSettingsSuccessfullyUpdated',
          severity: 'success',
        }),
      );
    }
    yield put(updateProfileSettingsInfoSuccess());
  } catch (err) {
    if (
      !get(err, 'response.data.success') &&
      get(err, 'response.data.code_error') === 2000
    ) {
      yield put(
        setToasterOpen({
          title: 'currentPasswordIncorrect',
          severity: 'error',
        }),
      );
    } else {
      yield put(
        setToasterOpen({
          title: 'defaultErrorMessage',
          severity: 'error',
        }),
      );
    }
    yield put(updateProfileSettingsInfoFail());
  }
}

export function* watchUpdateProfileSettingsInfo() {
  yield takeLatest(UPDATE_PROFILE_SETTINGS_INFO, updateProfileSettingsInfo);
}

export function* getUserInfo() {
  try {
    const response = yield call(getUserInfoAPI);
    const tabs = tabsFromResponse(get(response, 'data.data.privilege'));
    yield put(setSelectedTab(tabs[0]?.type as string));
    yield put(SetTabs(tabs));
    const {
      cin,
      drpp,
      email,
      login,
      phone,
      dob: bday,
      first_name: firstName,
      last_name: lastName,
    } = get(response, 'data.data');

    yield put(
      getUserInfoSuccess({
        firstName,
        lastName,
        cin,
        drpp,
        email,
        login,
        phone,
        bday: moment(bday).format('DD/MM/YYYY'),
      }),
    );
  } catch (error) {
    const tabs = yield select(getTabsSelector);
    if (tabs.length > 0) {
      yield put(SetTabs([]));
      yield put(
        setToasterOpen({
          title: 'sessionExpired',
          severity: 'error',
        }),
      );
    }
    localStorage.removeItem('token');
    yield put(getUserInfoFail());
  }
}

export function* watchGetUserInfo() {
  yield takeLatest(GET_USER_INFO, getUserInfo);
}

export function* verifyIdentity(payload: any) {
  try {
    yield put(setIdentityImages(payload));
    const { data: response } = yield call(verifyIdentityAPI);
    yield put(setPinId(get(response, 'data.pinId')));
    yield put(setToken(get(response, 'data.token')));
    yield put(setSignupStep(AUTH_EPARGN_SMS_UNVALID_USER));
  } catch (error) {
    yield put(
      setToasterOpen({
        title: 'defaultErrorMessage',
        severity: 'error',
      }),
    );
  }
}
